import React from "react";
import linkClicked from "../helpers/linkClicked";
import { GlobeOutline, LogoGithub } from "react-ionicons";

const ProjectModal = (props) => {
  let {
    active,
    projectBoxClicked,
    title,
    desc,
    gitHubLink,
    liveLink,
    imgs,
    tech,
    live,
  } = props;
  return (
    <div className={"modal " + (active ? "is-active" : "")}>
      <div onClick={projectBoxClicked} className="modal-background"></div>
      <div className="modal-card">
        {/* <header className="modal-card-head">
            <p className="modal-card-title">{title}</p>
            </header> */}
        <button
          onClick={projectBoxClicked}
          className="delete upper-right"
          aria-label="close"
        ></button>
        <section className="modal-card-body">
          <img src={imgs[0]} alt="Projects" />
          <h4 className="underline">{title}</h4>
          <p>{desc}</p>
          <h5 className="underline">Tech Stack</h5>
          <p>{tech}</p>
        </section>
        <footer className="modal-card-foot">
          {gitHubLink ? (
            <button
              onClick={(e) => {
                linkClicked(e, gitHubLink);
              }}
              className="button"
            >
              <div className="modal-logo">
                <LogoGithub />
              </div>
              View Github
            </button>
          ) : null}

          <button
            onClick={(e) => {
              linkClicked(e, liveLink);
            }}
            className={"button " + (live ? "" : "not-live")}
          >
            <div className="modal-logo">
              <GlobeOutline />
            </div>
            View Live!
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ProjectModal;
